<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Edit Presence Contact</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content class="bottom-extra-gap">
      <ng-container>
        @if (presenceContactPrivileges.canEdit) {
          <mat-form-field class="flex-full">
            <mat-label>DND Status</mat-label>
            <input
              matInput
              autocomplete="off"
              type="text"
              [formControl]="form.get('dndStatus')"
              id="dndStatus"
              />@if (form.get('dndStatus')?.hasError('maxlength')) {
              <mat-error>
                DND Status name cannot be more than 50 characters long. </mat-error
                >
              }@if (form.get('dndStatus')?.hasError('pattern') || form.get('dndStatus')?.hasError('whitespace')) {
              <mat-error
                >
                DND Status cannot contain leading/trailing spaces.
              </mat-error>
            }
          </mat-form-field>
        }
      </ng-container>
      <ng-container>
        @if (extensionPhonePrivileges.canEdit) {
          <mat-form-field class="flex-full">
            <mat-label>Office</mat-label>
            <input
              matInput
              autocomplete="off"
              type="text"
              [formControl]="form.get('office')"
              id="office"
              />@if (form.get('office')?.hasError('maxlength')) {
              <mat-error>
                Office name cannot be more than 255 characters long. </mat-error
                >
              }@if (form.get('office')?.hasError('pattern') || form.get('office')?.hasError('whitespace')) {
              <mat-error
                >
                Office name cannot contain leading/trailing spaces.
              </mat-error>
            }
          </mat-form-field>
        }
      </ng-container>
      <ng-container>
        @if (extensionPhonePrivileges.canEdit) {
          <ndt-department-chip-input
            class="flex-half"
            formControlName="departmentExtensions"
            [accountId]="selectedAccountId"
            [extensionId]="presenceContactExtensionId"
            [canCreateDepartments]="departmentPrivileges?.canAdd && departmentPrivileges?.canEdit"
          ></ndt-department-chip-input>
        }
      </ng-container>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button type="submit" title="Create" mat-raised-button>Save</button>
    </mat-dialog-actions>
  </form>
</lcs-loading-overlay>
